<template>
  <el-input
    ref="password-input"
    class="cloud-password"
    :class="{ 'cloud-password-padding': showEye }"
    :value="value"
    @input="onInput($event)"
    @blur="onBlurChangeType"
    :type="inputType"
    @focus="onFocus($event)"
    :tips="tips"
    :maxlength="maxlength"
    :data-input-type="dataType"
    :tips-max-width="tipsMaxWidth"
    v-input-limit
    :readonly="readonly"
    :auto-complete="autoComplete"
    :placeholder="placeholder"
    :validate-event="validateEvent"
    @copy.native.prevent="handelFlase"
    @paste.native.prevent="handelFlase"
    @cut.native.prevent="handelFlase"
  >
    <i
      slot="suffix"
      class="el-input__icon"
      :class="iconClass"
      v-if="showEye"
      @mouseenter="changeIconClick(1)"
      @mouseleave="changeIconClick(2)"
      @click="changeDisplayPassword()"
    ></i>
  </el-input>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    newModel: {
      type: Boolean,
      default: false
    },
    tipsMaxWidth: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: function () {
        return this.newModel ? 16 : 32;
      }
    },
    tips: {
      type: String,
      default: function () {
        return '';
      }
    },
    editMode: {
      type: Boolean,
      default: false
    },
    autoComplete: {
      type: String,
      default: ''
    },
    dataType: {
      type: String,
      default: function () {
        return this.newModel ? 'cloud-password' : '';
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    forceShowEyes: {
      type: Boolean,
      default: false
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      notModified: true,
      inputType: 'password',
      iconClass: '',
      showEye: false,
      iconClick: false,
      focusElm: {},
      inputValue: ''
    };
  },
  created: function () {
    if (this.editMode && this.notModified) {
      this.iconClass = '';
    } else {
      this.iconClass = 'icomoon-common__password_invisible';
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.autofocus) {
        this.$refs['password-input'].$refs.input.focus();
      }
    });
  },
  methods: {
    onBlurChangeType() {
      if (!this.iconClick) {
        this.inputType = 'password';
        this.iconClass = 'icomoon-common__password_invisible';
        this.showEye = false;
      } else {
        this.inputType = 'password';
        this.iconClass = 'icomoon-common__password_invisible';
      }
    },
    onInput(val) {
      this.$emit('input', val);
      this.inputValue = val;
      this.notModified = false;
      if ('' === val) {
        this.showEye = true;
      }
      // this.iconClass = 'icomoon-common__password_invisible';
      // this.inputType = 'password';
    },
    onFocus(e) {
      this.focusElm = e.target;
      if (this.editMode && this.notModified) {
        e.target.select();
      }
      if ('' === this.inputValue) {
        this.showEye = true;
      }
      // if (this.value) {
      //     this.showEye = false;
      // }
      if (this.forceShowEyes) {
        this.showEye = true;
      }
      this.$emit('focus');
    },
    changeDisplayPassword() {
      if (this.inputType === 'password') {
        this.inputType = 'text';
        this.iconClass = 'icomoon-common_password_visible';
      } else if (this.inputType === 'text') {
        this.inputType = 'password';
        this.iconClass = 'icomoon-common__password_invisible';
      }
    },
    changeIconClick(val) {
      this.iconClick = 1 === val;
      if (2 === val) {
        this.focusElm.select();
      }
    },
    // onMousedownClick() {
    //     this.inputType = 'text';
    //     this.iconClass = 'icomoon-common_password_visible';
    // },
    // onMouseupClick() {
    //     this.inputType = 'password';
    //     this.iconClass = 'icomoon-common__password_invisible';
    // }
    handelFlase() {
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.cloud-password {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
input::-ms-reveal {
  display: none;
}

.cloud-password {
  /*.el-input__suffix {*/
  /*    background: #FFFFFF;*/
  /*}*/
  &.cloud-password-padding {
    .el-input__inner {
      padding-right: 40px;
    }
  }
}
</style>
